import { IWorkShiftTimeSlot } from "../workShiftTimeSlot/workShiftTimeSlot";

export interface WorkShiftDto {
    workShiftId: string;
    effectiveDate: string;
    startTime: string;
    endTime: string;
    workShiftTimeSlots: IWorkShiftTimeSlot[];
    startTimeZoneName: string;
    startTimePlannedWorkShiftId?: string;
    splitAt?: string | null;
}

export interface WorkShift {
    workShiftId: string;
    effectiveDate: string;
    startTime: string;
    endTime: string;
    workShiftTimeSlotIds: string[];
    startTimeZoneName: string;
    startTimePlannedWorkShiftId?: string;
    splitAt?: string | null;
}

export const getWorkShift = ({
    workShiftId,
    effectiveDate,
    startTime,
    endTime,
    workShiftTimeSlots,
    startTimeZoneName,
    startTimePlannedWorkShiftId,
    splitAt,
}: WorkShiftDto) => ({
    workShiftId,
    effectiveDate,
    startTime,
    endTime,
    workShiftTimeSlotIds: workShiftTimeSlots.map((s) => s.id),
    startTimeZoneName,
    startTimePlannedWorkShiftId,
    splitAt,
});
